import _ from 'lodash'

export const sectorChoices = [
  {
    label: '3D Printing',
    value: '3d_printing',
  },
  {
    label: 'Advanced Materials',
    value: 'advanced_materials',
  },
  {
    label: 'Aerospace',
    value: 'aerospace',
  },
  {
    label: 'Agriculture',
    value: 'agriculture',
  },
  {
    label: 'AI',
    value: 'ai',
  },
  {
    label: 'Art & Design',
    value: 'art_and_design',
  },
  {
    label: 'Automotive',
    value: 'automotive',
  },
  {
    // deprecated, use automative or transport_and_logistics
    label: 'Automotive & Transport',
    value: 'automotive_and_transport',
  },
  {
    label: 'Biotechnology',
    value: 'biotechnology',
  },
  {
    label: 'Blockchain',
    value: 'blockchain',
  },
  {
    label: 'Chemistry',
    value: 'chemistry',
  },
  {
    label: 'Cleantech',
    value: 'cleantech',
  },
  {
    label: 'Construction',
    value: 'construction',
  },
  {
    label: 'Data & Analytics',
    value: 'data_and_analytics',
  },
  {
    label: 'Drones',
    value: 'drones',
  },
  {
    label: 'E-commerce',
    value: 'e_commerce',
  },
  {
    label: 'Education',
    value: 'education',
  },
  {
    label: 'Electronics',
    value: 'electronics',
  },
  {
    label: 'Energy',
    value: 'energy',
  },
  {
    label: 'Fashion',
    value: 'fashion',
  },
  {
    label: 'Fintech',
    value: 'fintech',
  },
  {
    label: 'FMCG',
    value: 'fmcg',
  },
  {
    label: 'Food & Beverage',
    value: 'food_and_beverage',
  },
  {
    label: 'Gaming',
    value: 'gaming',
  },
  {
    label: 'Hardware',
    value: 'hardware',
  },
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'ICT',
    value: 'ict',
  },
  {
    label: 'Industry',
    value: 'industry',
  },
  {
    label: 'Insurtech',
    value: 'insurtech',
  },
  {
    label: 'Internet',
    value: 'internet',
  },
  {
    label: 'IoT',
    value: 'iot',
  },
  {
    label: 'IT',
    value: 'it',
  },
  {
    label: 'Legal',
    value: 'legal',
  },
  {
    label: 'Lifestyle',
    value: 'lifestyle',
  },
  {
    // deprecated, use transport and logistics
    label: 'Distribution & Logistics',
    value: 'logistics',
  },
  {
    label: 'Manufacturing',
    value: 'manufacturing',
  },
  {
    label: 'Marine',
    value: 'marine',
  },
  {
    label: 'Marketing & Advertising',
    value: 'marketing_and_advertising',
  },
  {
    label: 'Marketplace',
    value: 'marketplace',
  },
  {
    label: 'Media & Entertainment',
    value: 'media_and_entertainment',
  },
  {
    label: 'Healthcare & Medtech',
    value: 'medtech_and_healthcare',
  },
  {
    label: 'Mining',
    value: 'mining',
  },
  {
    label: 'Mobile',
    value: 'mobile',
  },
  {
    label: 'Nanotechnology',
    value: 'nanotechnology',
  },
  {
    label: 'Oil & Gas',
    value: 'oil_and_gas',
  },
  {
    label: 'Pharma',
    value: 'pharma',
  },
  {
    label: 'Real Estate',
    value: 'real_estate',
  },
  {
    label: 'Recruitment',
    value: 'recruitment',
  },
  {
    label: 'Retailing',
    value: 'retailing',
  },
  {
    label: 'Robotics',
    value: 'robotics',
  },
  {
    label: 'SaaS',
    value: 'saas',
  },
  {
    label: 'Security & Cybersecurity',
    value: 'security_and_cybersecurity',
  },
  {
    label: 'Sharing Economy',
    value: 'sharing_economy',
  },
  {
    label: 'Smart Cities',
    value: 'smart_cities',
  },
  {
    label: 'Social Networking',
    value: 'social_networking',
  },
  {
    label: 'Sports',
    value: 'sports',
  },
  {
    label: 'Telecommunications',
    value: 'telecommunications',
  },
  {
    label: 'Transport & Logistics',
    value: 'transport',
  },
  {
    label: 'Travel',
    value: 'travel',
  },
  {
    label: 'VR & AR',
    value: 'vr_ar',
  },
  {
    label: 'Enterprise Software',
    value: 'enterprise_software',
  },
]

export function getSectorChoices() {
  return sectorChoices
}
export const sectorChoiceByValue = _.keyBy(sectorChoices, 'value')
export const sectorChoiceByLabel = _.keyBy(sectorChoices, 'label')
export const sectorValuesList = sectorChoices.map((s) => s.value)

export function sectorLabel(val) {
  const choice = sectorChoiceByValue[val]
  if (choice) {
    return choice.label
  } else {
    return ''
  }
}

export function sectorValue(sectorName) {
  const choice = sectorChoiceByLabel[sectorName]
  return choice ? choice.value : ''
}
